export class GcsListPrefixesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subPrefixes",
            "baseName": "subPrefixes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "sampleObjects",
            "baseName": "sampleObjects",
            "type": "Array<GcsSampleObject>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcsListPrefixesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
